// Categories
export const RESET_CATEGORIES_STATE = 'LAB_ASSISTANT_RESET_CATEGORIES_STATE';
export const CATEGORIES_LOADING = 'LAB_ASSISTANT_CATEGORIES_LOADING';
export const CATEGORIES_LOADED = 'LAB_ASSISTANT_CATEGORIES_LOADED';
export const CATEGORIES_ERROR = 'LAB_ASSISTANT_CATEGORIES_ERROR';

// Borrowed Items
export const RESET_BORROWED_ITEMS_STATE =
  'LAB_ASSISTANT_RESET_BORROWED_ITEMS_STATE';
export const BORROWED_ITEMS_LOADING = 'LAB_ASSISTANT_BORROWED_ITEMS_LOADING';
export const BORROWED_ITEMS_LOADED = 'LAB_ASSISTANT_BORROWED_ITEMS_LOADED';
export const BORROWED_ITEMS_ERROR = 'LAB_ASSISTANT_BORROWED_ITEMS_ERROR';

// Temp Borrowed Items
export const RESET_TEMP_BORROWED_ITEMS_STATE =
  'LAB_ASSISTANT_RESET_TEMP_BORROWED_ITEMS_STATE';
export const TEMP_BORROWED_ITEMS_LOADING =
  'LAB_ASSISTANT_TEMP_BORROWED_ITEMS_LOADING';
export const TEMP_BORROWED_ITEMS_LOADED =
  'LAB_ASSISTANT_TEMP_BORROWED_ITEMS_LOADED';
export const TEMP_BORROWED_ITEMS_ERROR =
  'LAB_ASSISTANT_TEMP_BORROWED_ITEMS_ERROR';

// Display Items Page
export const RESET_DISPLAY_ITEMS_STATE =
  'LAB_ASSISTANT_RESET_DISPLAY_ITEMS_STATE';
export const DISPLAY_ITEMS_LOADING = 'LAB_ASSISTANT_DISPLAY_ITEMS_LOADING';
export const DISPLAY_ITEMS_LOADED = 'LAB_ASSISTANT_DISPLAY_ITEMS_LOADED';
export const DISPLAY_ITEMS_ERROR = 'LAB_ASSISTANT_DISPLAY_ITEMS_ERROR';

// Items Page
export const RESET_ITEMS_STATE = 'LAB_ASSISTANT_RESET_ITEMS_STATE';
export const RESET_NEW_ITEM_STATE = 'LAB_ASSISTANT_RESET_NEW_ITEM_STATE';
export const ITEMS_LOADING = 'LAB_ASSISTANT_ITEMS_LOADING';
export const ITEMS_LOADED = 'LAB_ASSISTANT_ITEMS_LOADED';
export const ITEMS_ERROR = 'LAB_ASSISTANT_ITEMS_ERROR';
export const NEW_ITEM_LOADING = 'LAB_ASSISTANT_NEW_ITEM_LOADING';
export const NEW_ITEM_SUCCESS = 'LAB_ASSISTANT_NEW_ITEM_SUCCESS';
export const NEW_ITEM_FAIL = 'LAB_ASSISTANT_NEW_ITEM_FAIL';
export const ITEM_DELETE_LOADING = 'LAB_ASSISTANT_ITEM_DELETE_LOADING';
export const ITEM_DELETE_SUCCESS = 'LAB_ASSISTANT_ITEM_DELETE_SUCCESS';
export const ITEM_DELETE_FAIL = 'LAB_ASSISTANT_ITEM_DELETE_FAIL';
